import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { get_purchase } from "../../../../Controllers/Purchases/Orders";
import moment from "moment";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import URL from "../../../../Main/url";
import { Button } from "antd";
import Header from "../../../../Componets/Header";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import headers from "../../../../Data/Forms/Purchases/Orders/headers";
import CurrencyWord from "../../../../Componets/Currencywords";
import formatDateDDMMYYYY from "../../../../Main/formatDate";
import UserCurrency from "../../../../Componets/UserCurrency";
import { get_user_auth } from "../../../../Controllers/Layouts/Layouts";

const PurchaseView = () => {
  const componentRef = useRef();
  let { id } = useParams();

  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState();
  const [header, setHeader] = useState(headers);
  const [authorizeMail, setAuthorizeMail] = useState(false);

  const fetchData = async () => {
    setLoader(true);
    let data = { id };
    let purchase = await get_purchase(data);
    if (purchase?.status) {
      setDetails(purchase?.data);
      setLoader(false);
    } else {
      toast?.error(purchase?.message);
      setLoader(false);
    }
  };

  const fetchAuthorizeUser = async () => {
    try {
      setLoader(true);
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email =
          response?.data?.branch?.plan === 3000 && response?.data?.email?.trim().toLowerCase() ===
          process.env.REACT_APP_CROWN_PHARMACY_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch User Auth");
      }
    } catch (errors) {
      setLoader(false);
      toast?.error(errors?.message);
    }
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
      }

      @media print {
        .a4-invoice-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }

        .a4-invoice-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
    fetchAuthorizeUser();
    injectScopedStyles();
  }, []);

  const capitalizeWords = (str) => {
    if (!str) return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Header headers={header} setHeaders={setHeader}>
      <Loadercomponent loader={loader}>
        <div className="pb-4">
          <div className="flex justify-end flex-wrap">
            <div className="p-2">
              <ReactToPrint
                trigger={() => (
                  <Button
                    className="bg-white border rounded hover:border-green-500"
                    type="button"
                    size="large"
                  >
                    A4 Print <PrinterOutlined className="text-lg" />
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </div>
          </div>
        </div>
        <ScrollWrapper>
          <div
            className="flex justify-center a4-invoice-container"
            ref={componentRef}
          >
            <div className="px-4 w-full">
              <div className="flex justify-between items-start pb-4">
                <div className="text-black-900 text-[0.65rem]">
                  <div className="text-bold text-md">
                    {capitalizeWords(details?.branch?.name)}
                  </div>
                  <div className="text-medium text-xs">
                    Email&nbsp;:&nbsp;
                    {details?.branch?.email ? details.branch.email + ", " : ""}
                  </div>
                  <div className="text-medium text-xs">
                    Phone&nbsp;:&nbsp;
                    {details?.branch?.phone ? details.branch.phone : ""}
                  </div>
                  <div className="text-xs">
                    {details?.branch?.area ? details.branch.area + ", " : ""}
                    {details?.branch?.city ? details.branch.city + ", " : ""}
                    {details?.branch?.country ? details.branch.country : ""}
                  </div>
                  <div className="text-xs">
                    VATIN&nbsp;:&nbsp;
                    {details?.branch?.tax ? details.branch.tax : "N/A"}
                  </div>
                </div>

                {details?.branch?.image ? (
                  <div className="flex justify-center flex-col items-center">
                    <div className="text-xl pb-2">
                      <img
                        className="w-[50px] h-[50px]"
                        src={`${URL}/uploads${details.branch.image}`}
                        alt="Branch Logo"
                      />
                    </div>
                    <div className="text-bold text-lg">
                      {capitalizeWords(details?.branch?.name)}
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-center flex-col items-center">
                    <div className="w-[50px] h-[50px] rounded-md bg-gray-300 text-black flex items-center justify-center text-xl font-semibold">
                      {details?.branch?.name
                        ? details.branch.name.charAt(0).toUpperCase()
                        : "N"}
                    </div>
                    <div className="text-bold text-lg">
                      {capitalizeWords(details?.branch?.name)}
                    </div>
                  </div>
                )}
              </div>

              <hr className="my-2 border-t-black-900 border-black" />
              <div className="text-medium text-md text-center py-1">
                Purchase Received
              </div>
              <hr className="my-2 border-t-black-900 border-black" />

              <div className="border border-gray-300 rounded-lg p-4 mb-4 shadow-sm">
                <div className="flex justify-between">
                  <div className="text-[0.65rem] space-y-1">
                    <div className="font-semibold">
                      {details?.supplier?.name}
                    </div>
                    <div>
                      PHONE : {details?.supplier?.phone}
                      {details?.supplier?.email
                        ? ", EMAIL : " + details?.supplier?.email
                        : ""}
                    </div>
                    <div>{details?.supplier?.area}</div>
                    <div>
                      {details?.supplier?.city
                        ? details?.supplier?.city + ", "
                        : ""}
                      {details?.supplier?.state}
                    </div>
                    <div>{details?.supplier?.country}</div>
                    <div>
                      {details?.supplier?.tax
                        ? "VATIN : " + details?.supplier?.tax
                        : ""}
                    </div>
                  </div>

                  <div className="text-[0.65rem] space-y-1">
                    <div className="flex">
                      <div className="w-24">Purchase No</div>
                      <div className="px-2">:</div>
                      <div className="text-right">#PO-{details?.number}</div>
                    </div>
                    <div className="flex">
                      <div className="w-24">Invoice</div>
                      <div className="px-2">:</div>
                      <div className="text-right">{details?.invoice}</div>
                    </div>
                    <div className="flex">
                      <div className="w-24">Date</div>
                      <div className="px-2">:</div>
                      <div className="text-right">
                        {formatDateDDMMYYYY(details?.date)}
                      </div>
                    </div>
                    <div className="flex">
                      <div className="w-24">Due</div>
                      <div className="px-2">:</div>
                      <div className="text-right">
                        {formatDateDDMMYYYY(details?.due_date)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="min-h-[400px]">
                <table className="w-full border-separate border-spacing-0 rounded-lg overflow-hidden border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="text-[0.60rem] text-left py-2 pl-3 border-b border-gray-300 rounded-tl-lg">
                        S.No
                      </th>
                      <th className="text-[0.60rem] text-left p-2 border-b border-gray-300">
                        Item Code
                      </th>
                      <th className="text-[0.60rem] text-left p-2 border-b border-gray-300">
                        Description
                      </th>
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Units
                      </th>
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Quantity
                      </th>
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Foc
                      </th>
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Price
                      </th>
                      {authorizeMail && <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        % of Margin
                      </th>}
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Tax
                      </th>
                      <th className="text-[0.60rem] text-center p-2 border-b border-gray-300">
                        Taxamount
                      </th>
                      <th className="text-[0.60rem] text-right pr-2 border-b border-gray-300 rounded-tr-lg">
                        Total
                      </th>
                    </tr>
                  </thead>

                  <tbody className="text-sm">
                    {details?.details?.map((value, index) => {
                      const isLastDataRow =
                        index === details.details.length - 1;
                      const isLastOverallRow =
                        details.details.length >= 8 ? isLastDataRow : false;

                      return (
                        <tr key={index} className="hover:bg-gray-50 uppercase">
                          <td
                            className={`text-[0.60rem] p-1 pl-3 ${isLastOverallRow ? "rounded-bl-lg" : ""
                              }`}
                          >
                            {index + 1}
                          </td>
                          <td className="text-[0.60rem] p-1">
                            {value?.description?.item_code}
                          </td>
                          <td className="p-1">
                            <div className="text-[0.60rem]">{value?.name}</div>

                            {value?.batch && (
                              <div className="text-[0.50rem] text-gray-500 leading-tight">
                                Batch: {value.batch}
                              </div>
                            )}
                            {value?.expiry_date && (
                              <div className="text-[0.50rem] text-gray-500 leading-tight">
                                Exp:{" "}
                                {new Date(value.expiry_date).toLocaleDateString(
                                  "en-GB",
                                )}
                              </div>
                            )}
                          </td>
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.unit_name}
                          </td>
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.quantity}
                          </td>
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.free || 0}
                          </td>
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.purchase_price?.toFixed(3)}
                          </td>
                          {authorizeMail && <td className="text-[0.60rem] text-center p-1">
                            {(() => {
                              const sp = Number(value?.sale_price);
                              const cp = Number(value?.price_per_unit);

                              if (!sp || sp <= 0 || !cp || cp < 0)
                                return "0.000";

                              const margin = ((sp - cp) / sp) * 100;

                              return margin.toFixed(3);
                            })()}
                          </td>}
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.tax?.rate || 0}%
                          </td>
                          <td className="text-[0.60rem] text-center p-1">
                            {value?.tax_amount?.toFixed(3)}
                          </td>
                          <td
                            className={`text-[0.60rem] text-right pr-2 ${isLastOverallRow ? "rounded-br-lg" : ""
                              }`}
                          >
                            {value?.total?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}

                    {(!details?.details || details.details.length < 8) &&
                      Array.from({
                        length: 8 - (details?.details?.length || 0),
                      }).map((_, index, arr) => {
                        const lastRowRounded =
                          details?.details?.length === 0
                            ? index === arr.length - 1
                            : details?.details.length + index === 7;

                        return (
                          <tr
                            key={`empty-${index}`}
                            className="hover:bg-gray-50"
                          >
                            <td
                              className={`text-[0.60rem] p-4 pl-3 ${lastRowRounded ? "rounded-bl-lg" : ""
                                }`}
                            >
                              &nbsp;
                            </td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td className="p-3">&nbsp;</td>
                            <td
                              className={`text-right text-[0.60rem] p-1 pr-2 ${lastRowRounded ? "rounded-br-lg" : ""
                                }`}
                            >
                              &nbsp;
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>

                <div className="flex justify-between items-start pt-6 gap-6">
                  <div className="text-[0.60rem] w-1/2">
                    <div className="font-semibold">
                      Total in words&nbsp;:&nbsp;
                      <span className="font-normal">
                        <CurrencyWord amount={details?.total?.toFixed(3)} />
                      </span>
                    </div>
                  </div>

                  <div className="text-[0.60rem] w-1/2">
                    <div className="bg-gray-100 border border-gray-300 rounded-lg p-3 shadow-sm">
                      <table className="w-full text-[0.60rem]">
                        <tbody>
                          <tr>
                            <td className="text-right pr-2 py-1">Subtotal</td>
                            <td className="text-right w-20 py-1">
                              {details?.subtotal?.toFixed(3)}
                            </td>
                          </tr>

                          <tr>
                            <td className="text-right pr-2 py-1">VAT (5%)</td>
                            <td className="text-right py-1">
                              {details?.taxamount?.toFixed(3)}
                            </td>
                          </tr>

                          <tr>
                            <td className="text-right pr-2 py-1">Discount</td>
                            <td className="text-right py-1">
                              {details?.discount_type
                                ? details?.discount_value
                                  ? `${details?.discount?.toFixed(3)} (-${details?.discount_value}%)`
                                  : "0.000"
                                : details?.discount
                                  ? `-${details?.discount?.toFixed(3)}`
                                  : "0.000"}
                            </td>
                          </tr>

                          <tr>
                            <td className="text-right pr-2 py-1">
                              Delivery Charges
                            </td>
                            <td className="text-right py-1">
                              {details?.delivery?.toFixed(3) || "0.000"}
                            </td>
                          </tr>

                          <tr className="border-t border-gray-400">
                            <td className="text-right pr-2 py-2 font-semibold">
                              Total (<UserCurrency />)
                            </td>
                            <td className="text-right py-2 font-semibold">
                              {details?.total?.toFixed(3)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default PurchaseView;